
import XButton from 'vux/src/components/x-button/index.vue'

import BScroll from 'better-scroll'
import { mapMutations, mapGetters } from 'vuex'
import { getComment } from '@/api/getData'
import Comment from '@/components/comment.vue'

export default {
data() {
return {
scroll: '',
comment: [],
isComment: false,
commentId: 0,
}
},
computed: {
...mapGetters(['currentMusic', 'currentTime', 'playerStatus']),
activeIndex() {
return this.currentMusic.lyric.findIndex((item, index, array) => {
let nextLyric = array[index + 1]

if (
item.time <= this.currentTime &&
(nextLyric ? this.currentTime < nextLyric.time : true)
) {
return index
}
})
},
bgStyle() {
return {
backgroundImage: `url(${this.currentMusic.imgUrl})`,
}
},
},
methods: {
...mapMutations(['changePlayerStatus', 'setMiniPlayer']),
goBack() {
this.setMiniPlayer(true)
this.isComment = false
this.$router.back()
},
async gotoComment() {
if (this.commentId == this.currentMusic.id) {
this.isComment = true
} else {
let result = await getComment(this.currentMusic.id)
this.commentId = this.currentMusic.id
this.parseComment(result.data.hotComments)
this.isComment = true
}
},
parseComment(data, id) {
this.comment = data.map((item, index) => {
return {
content: item.content,
likedCount: item.likedCount,
username: item.user.nickname,
avatarUrl: item.user.avatarUrl,
time: this.parseCommentDate(item.time),
}
})
},
parseCommentDate(time) {
let date = new Date(Number(time))
let year = date.getFullYear() == 2020 ? '' : `${date.getFullYear()}年`
return `${year}${date.getMonth() + 1}月${date.getDate()}日`
},
},
watch: {
activeIndex(newIndex) {
let lrc_item = this.$refs.lrc_item
this.scroll.scrollToElement(lrc_item[newIndex], 200, 0, true)
},
},
activated() {
if (!this.scroll) {
this.scroll = new BScroll(this.$refs.lrc)
} else {
this.scroll.refresh()
}
if (this.commentId == this.currentMusic.id) {
this.isComment = true
}
},
components: {
XButton,
Comment,
},
}
